import { PopupSignupComponent } from './popup-signup.component';
import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { SharedService } from '../../services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../services/Spinner.service';
import { ValidationService } from '../../services/validation.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import {User} from '../../models/user';
import { LocalStorage } from '../../services/local-storage';
import { PopupLogoutComponent } from '../../users/popup/popup-logout.component';
import { Meta } from '@angular/platform-browser';
import { ZizDeleteConfirmComponent } from './ziz-delete-confirm.component';

export interface ConfirmModel {
  title:string;
  message:string;
  segmentid: number;
  reportid: number;
  flag: string;
  recordDetail: any;

}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper"> <div class="modal-dialog">
          
               <div class="modal-content" *ngIf="rerenderpopupsent">
                 
                 <div class="poupupTitle">
                     <h5 class="modal-title">{{title || 'Report'}}</h5>
                      <button type="button" class="close pull-right" aria-label="Close" (click)="confirm()">
                                  <span aria-hidden="true">X</span>
                        </button>
                   </div>
                
                   <div class="modal-body">
                   <div class="firstPopup feebBackPopup" *ngIf="rerenderpopupsentsuccess">
                    <p>
                    <b>Thanks for your feedback.</b>
                    This ZIZ card has been sent to admin for review.
                    </p>
                     </div>

                   <div class="firstPopup feebBackPopup" *ngIf="rerenderpopupalreadysentsuccess">
                    <p>
                    This ZIZ card has already been marked as flagged!
                    </p>
                     </div>
                   </div>
                   <div class="modal-footer firstPopup">
                     <button type="button" class="btn btn-default btn-orange" (click)="confirm()">Continue</button>
                   </div>
                 </div>

               <div class="modal-content" *ngIf="rerenderpopup">
                 <div class="poupupTitle">
                     <h5 class="modal-title">{{title || 'Report'}}</h5>
                      <button type="button" class="close pull-right" aria-label="Close" (click)="confirm()">
                                  <span aria-hidden="true">X</span>
                        </button>
                   </div>
                <form method="POST" [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="form-horizontal formLabel" id="signup-form" novalidate="novalidate">
                   <div class="modal-body" style="padding-bottom:0px;">
                   <div class="firstPopup feebBackPopup">
                  
                    <b>Describe what happened</b>
                    <textarea class="popuptextArea" #textAreaValue formControlName="popuptextArea" name="popuptextArea" id="popuptextArea" placeholder="Please enter some description of report" style="padding: 10px;"></textarea>
                    
                     </div>
                   </div>
                   <div class="modal-footer firstPopup">
                     <button type="button" class="btn btn-default btn-orange" (click)="submitReport(textAreaValue.value)" [disabled]="!reportForm.valid">Continue</button>
                   </div>
                   </form>
                 </div> 

                 <div class="modal-content" *ngIf="rerenderpopupreason">
                 <div class="poupupTitle">
                    
                     <h5 class="modal-title">{{title || 'Report'}}</h5>
                        <button type="button" class="close pull-right" aria-label="Close" (click)="confirm()">
                                  <span aria-hidden="true">X</span>
                        </button>
          
                   </div>
                    
                   <div class="modal-body" style="padding-bottom:0px;">
                   <div class="firstPopup feebBackPopup">
                  
                   <p class="mr-t20 ">Help us understand what’s happening.</p>
                   <ul class="listBold mr-t30">
                    <ng-container *ngFor="let reportlist of reportList; let i =  index" [attr.data-index]="i">
                    <li id={{reportlist.id}} (click)="reportFeed(i, reportlist)">{{reportlist.name}}</li>
                    </ng-container>
                   </ul>
                   
                     </div>
                   </div>
                 </div> 


                     <!-- <div class="modal-content listingPopup">-->

                 
                      <div class="modal-content listingPopup" *ngIf="rerenderpopuplisting">

                   <div class="modal-body" style="padding-bottom:0px;">
                   <div class="firstPopup feebBackPopup">
                  <ul class="modalListing">
                 <input type="hidden"  value={{recordDetail}}>
                 <li (click)="showsharepopup()"><b>Share ZIZ Card</b>Send this card to friends.</li>
                   <li [ngClass]="{'disabled-text':flag=='true'}" (click)="showReportFeedback()"><b>Report</b>Seen something inappropriate, let us know.</li>
                   <li  (click)="deleteZizCard()"><b>Delete</b>Delete ziz card.</li>
                  </ul>
                 </div>
                   </div>
                   <div class="modal-footer firstPopup text-center">
                     <button type="button" class="btn btn-default btn-orange" (click)="confirm()">Close</button>
                   </div>
                 </div>

                  <div class="modal-content listingPopup" *ngIf="rerenderpopuplistingshare">

                   <div class="modal-body" style="padding-bottom:0px;">
                   <div class="firstPopup feebBackPopup">
                  <ul class="modalListing">
                 <li (click)="shareEmail()"><b>Share via Email</b>Send this to an email address.</li>
                  <li (click)="callShare()" ><b>Share via Facebook</b>Post this in your feed.</li>
                   <li (click)="callShareTwitter()" ><b>Share via Twitter</b>Send a tweet.</li>
                  </ul>
                   

                   <div >
      </div>
                     </div>
                   </div>


                   <div class="modal-footer firstPopup text-center">
                     <button type="button" class="btn btn-default btn-orange" (click)="confirm()">Close</button>
                   </div>
                 </div>

                       <div class="modal-content black" *ngIf="rerenderpopupShareZiZCard">

                   <div class="modal-body" style="padding-top:0px;">
                   <div class="feedLongPopupContainer">
                  <img src="assets/img/feedPopup.png">
                  <div class="feedLongPopupContent">
                 <p class="pull-left">Google Home is a voice-activated speaker powered <br> by the Google Assistant. Ask it questions. </p>
                  <div class="pull-right">  
                 <button class=" findDealBtn" value="Find Deal">Learn More</button>
                <button class=" dealButton" value="Find Deal"><i  class="icon icon-currentlocation"></i>Find Deal</button>
                </div>
                       <div class="clearfix"></div>  
                     <div class="feedLongExpired">EXPIRES IN: 1D 2H 5M 12S</div>
                 </div> 
              
          
                 </div>
                   </div>
   
                 </div>
              </div></div>`,
              providers : [SharedService, PopupLogoutComponent,ZizDeleteConfirmComponent,Meta],
})
export class PopupReportComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  token:string;
  title: string;
  message: string;
  segmentid: number;
  reportid: number;
  flag: string;
  rerenderpopupreason: boolean;
  rerenderpopuplisting: boolean;
  rerenderpopuplistingshare: boolean;
  rerenderpopupsent: boolean;
  rerenderpopup: boolean;
  rerenderpopupsentsuccess: boolean;
  rerenderpopupalreadysentsuccess: boolean;
  rerenderpopupShareZiZCard: boolean;
  reportForm: FormGroup;
  reportList = [];
  recordDetail: any = {"name":"", "heading":"","advertiserInfo":{"name":""}};
  imageUrl : string;
popTitle: string;
  sharedId  :string;
  subject : string;
  heading : string;
  advertiserName : string;
  public emailUrl = ""

   public repoUrl = this.shareService.shareUrl+this.sharedId;

  constructor(dialogService: DialogService, 
  private localstorage : LocalStorage,private shareService :SharedService,
  private loaderService : LoaderService,private router : Router, 
  private formBuilder: FormBuilder,private metaService:Meta) {
    super(dialogService);
    this.imageUrl = 'https://avatars2.githubusercontent.com/u/10674541?v=3&s=200';
    //this.rerenderpopupShareZiZCard=true;
    //this.rerenderpopupShareZiZCard=true;
         this.popTitle = "in home test";

     this.rerenderpopuplisting = true;
    this.token=this.localstorage.getStorage('token');
    
     this.reportForm = this.formBuilder.group({
       popuptextArea: [null, Validators.required]
   });



    //  this.rerenderpopuplisting = true;
     
  }
ngOnInit() {

    //     this.metaService.updateTag('og:description','testing in pop up report');
    // this.metaService.setTag('og:image','https://s3-ap-southeast-2.amazonaws.com/ziz-dev-bucket/campaignBanner/668/uXNHSOiWKL.jpeg');
    this.metaService.updateTag({
  content: 'https://s3-ap-southeast-2.amazonaws.com/ziz-dev-bucket/campaignBanner/668/uXNHSOiWKL.jpeg'
},
 "property='og:image'"
);
 this.metaService.updateTag({
  content: 'testing image in pop up'
},
 "property='og:description'"
);

this.metaService.updateTag({
  content: 'title in pop up'
},
 "property='og:title'"
); 
  }

  confirm() {
    this.result = true;
    this.close();
  }
  showReportFeedback() {
   this.rerenderpopuplisting = false; 
   this.rerenderpopupreason = true;
    this.shareService.CallDatawithToken("master/flagReasons",null,this.token).subscribe((result) => {
      if(result.data) {
        this.reportList = result.data;
      }
    });
  }
  deleteZizCard() {
    console.log(this.segmentid);
    let cdata ={
      "campaignId": this.segmentid
    };
    this.dialogService.addDialog(ZizDeleteConfirmComponent, {
      title: "Delete",
      message: "Do you want to delete this ZIZ card ?"
  }).subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.shareService.callApiWithToken("user/campaign/deleteForUser",cdata,this.token).subscribe((result) => {
          console.log(result);
          if(result.meta.code==200){
            this.showConfirm();
           // location.reload();
          } else {
            alert("Something went wrong with service.");
          }
        });
      } 
  });
}
showConfirm() {
  let disposable = this.dialogService.addDialog(PopupSignupComponent, {
      title:'Delete', 
      message:'Ziz card delete successfully.'})
      .subscribe((isConfirmed)=>{
          //We get dialog result
          if(isConfirmed) {
              //this.close();
              location.reload();
              //this.router.navigate(['users/wall']);
          }
          else {
              alert('declined');
          }
      });
  //We can close dialog calling disposable.unsubscribe();
  //If dialog was not closed manually close it by timeout
}
  reportFeed(id, reportlist) {
      id = id +1;
      this.reportid = id; 
      this.rerenderpopupreason=false;
      this.rerenderpopup = true;

}


submitReport(value: string) {
  var data = {"additionalTxt":value,
            "campaignId": this.segmentid,
            "reasonId": this.reportid};
    this.shareService.callApiWithToken('user/campaign/flag',data, this.token).subscribe((result) => {
      if(result.data) {
      this.rerenderpopupsent=true;
      this.rerenderpopupsentsuccess = true;
       this.rerenderpopup = false;
      this.rerenderpopupreason = false;
    }
    else {
        this.rerenderpopup = false;
       this.rerenderpopupsent=true;
       this.rerenderpopupsentsuccess = false;
      this.rerenderpopupalreadysentsuccess=true
    }
});
}
showsharepopup() {
  this.rerenderpopuplisting = false;
  this.rerenderpopuplistingshare = true;
   this.shareService.callApiWithToken("user/campaign/share/"+this.segmentid,null,this.token).subscribe((result) => {

 this.sharedId = result.data.sharedId;
    });
    console.log(this.recordDetail); 
this.subject = this.recordDetail.headingText;
this.heading =  this.recordDetail.description;
this.advertiserName = this.recordDetail.advertiserInfo.companyName;
}

callShare(){

     this.repoUrl = this.shareService.shareUrl+this.sharedId;


     var repoUrl = encodeURIComponent(this.repoUrl);
window.open(

  'https://www.facebook.com/sharer/sharer.php?u='+repoUrl,
  '_blank' // <- This is what makes it open in a new window.
);
 
}
callShareTwitter(){

       this.repoUrl = this.shareService.shareUrl+this.sharedId;


     var repoUrl = encodeURIComponent(this.repoUrl);

window.open(

  'https://twitter.com/intent/tweet/?text=Checkout the campaign at:&url='+repoUrl,
  '_blank' // <- This is what makes it open in a new window.
);
}
shareEmail() {

       this.repoUrl = this.shareService.shareUrl+this.sharedId;

 var subject  = encodeURIComponent (this.subject);
 var heading = encodeURIComponent(this.heading);
      var repoUrl = encodeURIComponent(this.repoUrl);

 var advertiserName = encodeURIComponent(this.advertiserName);

window.location.href= 'mailto:?subject='+subject+'&body=Hi, %0D%0A%0D%0A Check out this ZIZ offer: '+heading+' from '+ advertiserName+' at: %0D%0A%0D%0A%0D%0A'+repoUrl+ ' %0D%0A%0D%0A%0D%0A ZIZ the app connecting you to great offers. Checkout www.zizazz.com for more information.' ;
}


}

export declare class FacebookParams {
    u: string;
}
 
export class GooglePlusParams {
    url: string
}
 
export class LinkedinParams {
    url:string
}
 
export declare class PinterestParams {
    url: string;
    media: string;
    description: string;
}
 
export class TwitterParams {
    text: string;
    url: string;
    hashtags: string;
    via: string;
}

export class Email {
    text: string;
    url: string;
    hashtags: string;
    via: string;
}



// WEBPACK FOOTER //
// ./src/app/users/popup/popup-report.component.ts